import utilsFunction from "../../../utils/utilsFunction";

export const removeRowFromConditionTable = (table, key, id) => {


  // table.forEach((row, index) => {
  //   if (row[key] === id) {
  //     table.splice(index, 1)
  //   }
  // })

  const result = table.filter(row => row[key] !== id)

  // یه موردی هست  گفتن اگه طرف سطر اول رو حذف کرد باید
  // مقادیر سطر اول تبدیل بشه به  بدون شرط
  //من اینجا در هر صورت میگیرم موقع حذف مقادیر ردیف اول رو تغییر میدم
  // این یه استثنا هست و باید قبولش کرد

  if (result.length > 0) {
    result[0].textAndOr = "بدون شرط"
    result[0].andOr = "andOr"
  }

  return result


}


const conditionLabelValue = [
  {label: "بدون شرط", value: ""},
  {label: "و", value: "AND"},
  {label: "یا", value: "OR"},
]
const operatorSelectOption = [
  {label: "بزرگتر", value: ">"},
  {label: "بزرگتر مساوی", value: ">="},
  {label: "مساوی", value: "="},
  {label: "مخالف", value: "!="},
  {label: "کوچیکتر", value: "<"},
  {label: "کوچیکتر مساوی", value: "<="},
]
export const makeFullDataFromBackendData = (tableRows, listOfEntities) => {


  const newTableData = [...tableRows];

  newTableData.forEach(row => {


    row.uniqId = utilsFunction.randomNumberGenerator()
    row.textValue = row.value
    listOfEntities.forEach(item => {
      if (row.field === item.value) row.textField = item.label
    })
    operatorSelectOption.forEach(item => {
      if (item.value === row.operator) {
        row.textOperator = item.label
      }
    })
    conditionLabelValue.forEach(item => {
      if (row.andOr === item.value) {
        row.textAndOr = item.label
      }
    })

  })


  return newTableData

}